// source: profileservice/blog_order.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var profileservice_blog_pb = require('../profileservice/blog_pb.js');
goog.object.extend(proto, profileservice_blog_pb);
var profileservice_blog_charge_pb = require('../profileservice/blog_charge_pb.js');
goog.object.extend(proto, profileservice_blog_charge_pb);
var profileservice_blog_snapshot_pb = require('../profileservice/blog_snapshot_pb.js');
goog.object.extend(proto, profileservice_blog_snapshot_pb);
goog.exportSymbol('proto.profileservice.BlogOrder', null, global);
goog.exportSymbol('proto.profileservice.BlogOrderHistory', null, global);
goog.exportSymbol('proto.profileservice.CompleteBlogOrderReply', null, global);
goog.exportSymbol('proto.profileservice.CompleteBlogOrderRequest', null, global);
goog.exportSymbol('proto.profileservice.ExecutePaymentReply', null, global);
goog.exportSymbol('proto.profileservice.ExecutePaymentRequest', null, global);
goog.exportSymbol('proto.profileservice.GetBlogOrderHistoriesReply', null, global);
goog.exportSymbol('proto.profileservice.GetBlogOrderHistoriesRequest', null, global);
goog.exportSymbol('proto.profileservice.GetBlogOrderReply', null, global);
goog.exportSymbol('proto.profileservice.GetBlogOrderRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.ExecutePaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.ExecutePaymentRequest.repeatedFields_, null);
};
goog.inherits(proto.profileservice.ExecutePaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.ExecutePaymentRequest.displayName = 'proto.profileservice.ExecutePaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.ExecutePaymentReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.ExecutePaymentReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.ExecutePaymentReply.displayName = 'proto.profileservice.ExecutePaymentReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.CompleteBlogOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.CompleteBlogOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.CompleteBlogOrderRequest.displayName = 'proto.profileservice.CompleteBlogOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.CompleteBlogOrderReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.CompleteBlogOrderReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.CompleteBlogOrderReply.displayName = 'proto.profileservice.CompleteBlogOrderReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogOrderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.GetBlogOrderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogOrderRequest.displayName = 'proto.profileservice.GetBlogOrderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogOrderReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.GetBlogOrderReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.GetBlogOrderReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogOrderReply.displayName = 'proto.profileservice.GetBlogOrderReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.BlogOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogOrder.displayName = 'proto.profileservice.BlogOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogOrderHistoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.GetBlogOrderHistoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogOrderHistoriesRequest.displayName = 'proto.profileservice.GetBlogOrderHistoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.BlogOrderHistory = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.profileservice.BlogOrderHistory, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.BlogOrderHistory.displayName = 'proto.profileservice.BlogOrderHistory';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.profileservice.GetBlogOrderHistoriesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.profileservice.GetBlogOrderHistoriesReply.repeatedFields_, null);
};
goog.inherits(proto.profileservice.GetBlogOrderHistoriesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.profileservice.GetBlogOrderHistoriesReply.displayName = 'proto.profileservice.GetBlogOrderHistoriesReply';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.ExecutePaymentRequest.repeatedFields_ = [9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.ExecutePaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.ExecutePaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.ExecutePaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.ExecutePaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    paymentMethod: jspb.Message.getFieldWithDefault(msg, 2, 0),
    token: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cardSeq: jspb.Message.getFieldWithDefault(msg, 4, 0),
    blogId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    holderName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    callbackUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    gmoRedInfo: jspb.Message.getFieldWithDefault(msg, 8, ""),
    subaccountUserIdsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
    blockedUserIdsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    blockingUserIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.ExecutePaymentRequest}
 */
proto.profileservice.ExecutePaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.ExecutePaymentRequest;
  return proto.profileservice.ExecutePaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.ExecutePaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.ExecutePaymentRequest}
 */
proto.profileservice.ExecutePaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentMethod(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCardSeq(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolderName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCallbackUrl(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setGmoRedInfo(value);
      break;
    case 9:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSubaccountUserIdsList(value);
      break;
    case 10:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlockedUserIdsList(value);
      break;
    case 11:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setBlockingUserIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.ExecutePaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.ExecutePaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.ExecutePaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.ExecutePaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPaymentMethod();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCardSeq();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBlogId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHolderName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCallbackUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getGmoRedInfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSubaccountUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      9,
      f
    );
  }
  f = message.getBlockedUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      10,
      f
    );
  }
  f = message.getBlockingUserIdsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      11,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 payment_method = 2;
 * @return {number}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getPaymentMethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string token = 3;
 * @return {string}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 card_seq = 4;
 * @return {number}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getCardSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setCardSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 blog_id = 5;
 * @return {number}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getBlogId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setBlogId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string holder_name = 6;
 * @return {string}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getHolderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setHolderName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string callback_url = 7;
 * @return {string}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getCallbackUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setCallbackUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string gmo_red_info = 8;
 * @return {string}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getGmoRedInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setGmoRedInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated int32 subaccount_user_ids = 9;
 * @return {!Array<number>}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getSubaccountUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setSubaccountUserIdsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.addSubaccountUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.clearSubaccountUserIdsList = function() {
  return this.setSubaccountUserIdsList([]);
};


/**
 * repeated int32 blocked_user_ids = 10;
 * @return {!Array<number>}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getBlockedUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setBlockedUserIdsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.addBlockedUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.clearBlockedUserIdsList = function() {
  return this.setBlockedUserIdsList([]);
};


/**
 * repeated int32 blocking_user_ids = 11;
 * @return {!Array<number>}
 */
proto.profileservice.ExecutePaymentRequest.prototype.getBlockingUserIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.setBlockingUserIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.addBlockingUserIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.ExecutePaymentRequest} returns this
 */
proto.profileservice.ExecutePaymentRequest.prototype.clearBlockingUserIdsList = function() {
  return this.setBlockingUserIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.ExecutePaymentReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.ExecutePaymentReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.ExecutePaymentReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.ExecutePaymentReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentMethod: jspb.Message.getFieldWithDefault(msg, 1, 0),
    gmoOrderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accessId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    token: jspb.Message.getFieldWithDefault(msg, 4, ""),
    startUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
    startLimitDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    errCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    errInfo: jspb.Message.getFieldWithDefault(msg, 8, ""),
    errMessage: jspb.Message.getFieldWithDefault(msg, 9, ""),
    blogOrderId: jspb.Message.getFieldWithDefault(msg, 10, 0),
    price: jspb.Message.getFieldWithDefault(msg, 11, 0),
    amount: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.ExecutePaymentReply}
 */
proto.profileservice.ExecutePaymentReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.ExecutePaymentReply;
  return proto.profileservice.ExecutePaymentReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.ExecutePaymentReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.ExecutePaymentReply}
 */
proto.profileservice.ExecutePaymentReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPaymentMethod(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGmoOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStartLimitDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrInfo(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrMessage(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogOrderId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.ExecutePaymentReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.ExecutePaymentReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.ExecutePaymentReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.ExecutePaymentReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentMethod();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getGmoOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccessId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStartUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartLimitDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getErrCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getErrInfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getErrMessage();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBlogOrderId();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
};


/**
 * optional int32 payment_method = 1;
 * @return {number}
 */
proto.profileservice.ExecutePaymentReply.prototype.getPaymentMethod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setPaymentMethod = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string gmo_order_id = 2;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getGmoOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setGmoOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string access_id = 3;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getAccessId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setAccessId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string token = 4;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setToken = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string start_url = 5;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getStartUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setStartUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string start_limit_date = 6;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getStartLimitDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setStartLimitDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string err_code = 7;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getErrCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setErrCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string err_info = 8;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getErrInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setErrInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string err_message = 9;
 * @return {string}
 */
proto.profileservice.ExecutePaymentReply.prototype.getErrMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setErrMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 blog_order_id = 10;
 * @return {number}
 */
proto.profileservice.ExecutePaymentReply.prototype.getBlogOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setBlogOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 price = 11;
 * @return {number}
 */
proto.profileservice.ExecutePaymentReply.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setPrice = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 amount = 12;
 * @return {number}
 */
proto.profileservice.ExecutePaymentReply.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.ExecutePaymentReply} returns this
 */
proto.profileservice.ExecutePaymentReply.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.CompleteBlogOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.CompleteBlogOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CompleteBlogOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    gmoOrderId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resultJson: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.CompleteBlogOrderRequest}
 */
proto.profileservice.CompleteBlogOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.CompleteBlogOrderRequest;
  return proto.profileservice.CompleteBlogOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.CompleteBlogOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.CompleteBlogOrderRequest}
 */
proto.profileservice.CompleteBlogOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setGmoOrderId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResultJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.CompleteBlogOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.CompleteBlogOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CompleteBlogOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGmoOrderId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResultJson();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string gmo_order_id = 1;
 * @return {string}
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.getGmoOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CompleteBlogOrderRequest} returns this
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.setGmoOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string result_json = 2;
 * @return {string}
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.getResultJson = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.CompleteBlogOrderRequest} returns this
 */
proto.profileservice.CompleteBlogOrderRequest.prototype.setResultJson = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.CompleteBlogOrderReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.CompleteBlogOrderReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.CompleteBlogOrderReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CompleteBlogOrderReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogOrder: (f = msg.getBlogOrder()) && proto.profileservice.BlogOrder.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.CompleteBlogOrderReply}
 */
proto.profileservice.CompleteBlogOrderReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.CompleteBlogOrderReply;
  return proto.profileservice.CompleteBlogOrderReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.CompleteBlogOrderReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.CompleteBlogOrderReply}
 */
proto.profileservice.CompleteBlogOrderReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.BlogOrder;
      reader.readMessage(value,proto.profileservice.BlogOrder.deserializeBinaryFromReader);
      msg.setBlogOrder(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.CompleteBlogOrderReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.CompleteBlogOrderReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.CompleteBlogOrderReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.CompleteBlogOrderReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogOrder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.profileservice.BlogOrder.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlogOrder blog_order = 1;
 * @return {?proto.profileservice.BlogOrder}
 */
proto.profileservice.CompleteBlogOrderReply.prototype.getBlogOrder = function() {
  return /** @type{?proto.profileservice.BlogOrder} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.BlogOrder, 1));
};


/**
 * @param {?proto.profileservice.BlogOrder|undefined} value
 * @return {!proto.profileservice.CompleteBlogOrderReply} returns this
*/
proto.profileservice.CompleteBlogOrderReply.prototype.setBlogOrder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.CompleteBlogOrderReply} returns this
 */
proto.profileservice.CompleteBlogOrderReply.prototype.clearBlogOrder = function() {
  return this.setBlogOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.CompleteBlogOrderReply.prototype.hasBlogOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogOrderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogOrderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogOrderId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    blogId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    withBlogChargeReceipts: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogOrderRequest}
 */
proto.profileservice.GetBlogOrderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogOrderRequest;
  return proto.profileservice.GetBlogOrderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogOrderRequest}
 */
proto.profileservice.GetBlogOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogOrderId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogId(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithBlogChargeReceipts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogOrderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogOrderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogOrderId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getBlogId();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getWithBlogChargeReceipts();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.GetBlogOrderRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderRequest} returns this
 */
proto.profileservice.GetBlogOrderRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 blog_order_id = 2;
 * @return {number}
 */
proto.profileservice.GetBlogOrderRequest.prototype.getBlogOrderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderRequest} returns this
 */
proto.profileservice.GetBlogOrderRequest.prototype.setBlogOrderId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 blog_id = 3;
 * @return {number}
 */
proto.profileservice.GetBlogOrderRequest.prototype.getBlogId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderRequest} returns this
 */
proto.profileservice.GetBlogOrderRequest.prototype.setBlogId = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool with_blog_charge_receipts = 4;
 * @return {boolean}
 */
proto.profileservice.GetBlogOrderRequest.prototype.getWithBlogChargeReceipts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.profileservice.GetBlogOrderRequest} returns this
 */
proto.profileservice.GetBlogOrderRequest.prototype.setWithBlogChargeReceipts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.GetBlogOrderReply.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogOrderReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogOrderReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogOrderReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogOrder: (f = msg.getBlogOrder()) && proto.profileservice.BlogOrder.toObject(includeInstance, f),
    blogChargeReceiptsList: jspb.Message.toObjectList(msg.getBlogChargeReceiptsList(),
    profileservice_blog_charge_pb.BlogChargeReceipt.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogOrderReply}
 */
proto.profileservice.GetBlogOrderReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogOrderReply;
  return proto.profileservice.GetBlogOrderReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogOrderReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogOrderReply}
 */
proto.profileservice.GetBlogOrderReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.BlogOrder;
      reader.readMessage(value,proto.profileservice.BlogOrder.deserializeBinaryFromReader);
      msg.setBlogOrder(value);
      break;
    case 2:
      var value = new profileservice_blog_charge_pb.BlogChargeReceipt;
      reader.readMessage(value,profileservice_blog_charge_pb.BlogChargeReceipt.deserializeBinaryFromReader);
      msg.addBlogChargeReceipts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogOrderReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogOrderReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogOrderReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogOrder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.profileservice.BlogOrder.serializeBinaryToWriter
    );
  }
  f = message.getBlogChargeReceiptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      profileservice_blog_charge_pb.BlogChargeReceipt.serializeBinaryToWriter
    );
  }
};


/**
 * optional BlogOrder blog_order = 1;
 * @return {?proto.profileservice.BlogOrder}
 */
proto.profileservice.GetBlogOrderReply.prototype.getBlogOrder = function() {
  return /** @type{?proto.profileservice.BlogOrder} */ (
    jspb.Message.getWrapperField(this, proto.profileservice.BlogOrder, 1));
};


/**
 * @param {?proto.profileservice.BlogOrder|undefined} value
 * @return {!proto.profileservice.GetBlogOrderReply} returns this
*/
proto.profileservice.GetBlogOrderReply.prototype.setBlogOrder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.GetBlogOrderReply} returns this
 */
proto.profileservice.GetBlogOrderReply.prototype.clearBlogOrder = function() {
  return this.setBlogOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.GetBlogOrderReply.prototype.hasBlogOrder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated BlogChargeReceipt blog_charge_receipts = 2;
 * @return {!Array<!proto.profileservice.BlogChargeReceipt>}
 */
proto.profileservice.GetBlogOrderReply.prototype.getBlogChargeReceiptsList = function() {
  return /** @type{!Array<!proto.profileservice.BlogChargeReceipt>} */ (
    jspb.Message.getRepeatedWrapperField(this, profileservice_blog_charge_pb.BlogChargeReceipt, 2));
};


/**
 * @param {!Array<!proto.profileservice.BlogChargeReceipt>} value
 * @return {!proto.profileservice.GetBlogOrderReply} returns this
*/
proto.profileservice.GetBlogOrderReply.prototype.setBlogChargeReceiptsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.profileservice.BlogChargeReceipt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogChargeReceipt}
 */
proto.profileservice.GetBlogOrderReply.prototype.addBlogChargeReceipts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.profileservice.BlogChargeReceipt, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogOrderReply} returns this
 */
proto.profileservice.GetBlogOrderReply.prototype.clearBlogChargeReceiptsList = function() {
  return this.setBlogChargeReceiptsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    blogId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    orderType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    buyerId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sellerId: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogOrder}
 */
proto.profileservice.BlogOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogOrder;
  return proto.profileservice.BlogOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogOrder}
 */
proto.profileservice.BlogOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBlogId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrderType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBuyerId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSellerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBlogId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOrderType();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getBuyerId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getSellerId();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 blog_id = 2;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getBlogId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setBlogId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 order_type = 3;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getOrderType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setOrderType = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 status = 4;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 buyer_id = 5;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getBuyerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setBuyerId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 seller_id = 6;
 * @return {number}
 */
proto.profileservice.BlogOrder.prototype.getSellerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrder} returns this
 */
proto.profileservice.BlogOrder.prototype.setSellerId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogOrderHistoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogOrderHistoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderHistoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogOrderHistoriesRequest}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogOrderHistoriesRequest;
  return proto.profileservice.GetBlogOrderHistoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogOrderHistoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogOrderHistoriesRequest}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogOrderHistoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogOrderHistoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderHistoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 user_id = 1;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesRequest} returns this
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesRequest} returns this
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesRequest} returns this
 */
proto.profileservice.GetBlogOrderHistoriesRequest.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.BlogOrderHistory.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.BlogOrderHistory.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.BlogOrderHistory} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogOrderHistory.toObject = function(includeInstance, msg) {
  var f, obj = {
    blog: (f = msg.getBlog()) && profileservice_blog_pb.Blog.toObject(includeInstance, f),
    blogSnapshot: (f = msg.getBlogSnapshot()) && profileservice_blog_snapshot_pb.BlogSnapshot.toObject(includeInstance, f),
    blogOrderPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    blogChargeReceiptPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
    purchasedAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.BlogOrderHistory}
 */
proto.profileservice.BlogOrderHistory.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.BlogOrderHistory;
  return proto.profileservice.BlogOrderHistory.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.BlogOrderHistory} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.BlogOrderHistory}
 */
proto.profileservice.BlogOrderHistory.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new profileservice_blog_pb.Blog;
      reader.readMessage(value,profileservice_blog_pb.Blog.deserializeBinaryFromReader);
      msg.setBlog(value);
      break;
    case 2:
      var value = new profileservice_blog_snapshot_pb.BlogSnapshot;
      reader.readMessage(value,profileservice_blog_snapshot_pb.BlogSnapshot.deserializeBinaryFromReader);
      msg.setBlogSnapshot(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogOrderPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBlogChargeReceiptPath(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPurchasedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.BlogOrderHistory.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.BlogOrderHistory.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.BlogOrderHistory} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.BlogOrderHistory.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlog();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      profileservice_blog_pb.Blog.serializeBinaryToWriter
    );
  }
  f = message.getBlogSnapshot();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      profileservice_blog_snapshot_pb.BlogSnapshot.serializeBinaryToWriter
    );
  }
  f = message.getBlogOrderPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBlogChargeReceiptPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPurchasedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional Blog blog = 1;
 * @return {?proto.profileservice.Blog}
 */
proto.profileservice.BlogOrderHistory.prototype.getBlog = function() {
  return /** @type{?proto.profileservice.Blog} */ (
    jspb.Message.getWrapperField(this, profileservice_blog_pb.Blog, 1));
};


/**
 * @param {?proto.profileservice.Blog|undefined} value
 * @return {!proto.profileservice.BlogOrderHistory} returns this
*/
proto.profileservice.BlogOrderHistory.prototype.setBlog = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.BlogOrderHistory} returns this
 */
proto.profileservice.BlogOrderHistory.prototype.clearBlog = function() {
  return this.setBlog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.BlogOrderHistory.prototype.hasBlog = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BlogSnapshot blog_snapshot = 2;
 * @return {?proto.profileservice.BlogSnapshot}
 */
proto.profileservice.BlogOrderHistory.prototype.getBlogSnapshot = function() {
  return /** @type{?proto.profileservice.BlogSnapshot} */ (
    jspb.Message.getWrapperField(this, profileservice_blog_snapshot_pb.BlogSnapshot, 2));
};


/**
 * @param {?proto.profileservice.BlogSnapshot|undefined} value
 * @return {!proto.profileservice.BlogOrderHistory} returns this
*/
proto.profileservice.BlogOrderHistory.prototype.setBlogSnapshot = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.profileservice.BlogOrderHistory} returns this
 */
proto.profileservice.BlogOrderHistory.prototype.clearBlogSnapshot = function() {
  return this.setBlogSnapshot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.profileservice.BlogOrderHistory.prototype.hasBlogSnapshot = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string blog_order_path = 3;
 * @return {string}
 */
proto.profileservice.BlogOrderHistory.prototype.getBlogOrderPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.BlogOrderHistory} returns this
 */
proto.profileservice.BlogOrderHistory.prototype.setBlogOrderPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string blog_charge_receipt_path = 4;
 * @return {string}
 */
proto.profileservice.BlogOrderHistory.prototype.getBlogChargeReceiptPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.profileservice.BlogOrderHistory} returns this
 */
proto.profileservice.BlogOrderHistory.prototype.setBlogChargeReceiptPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 purchased_at = 5;
 * @return {number}
 */
proto.profileservice.BlogOrderHistory.prototype.getPurchasedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.BlogOrderHistory} returns this
 */
proto.profileservice.BlogOrderHistory.prototype.setPurchasedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.profileservice.GetBlogOrderHistoriesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.profileservice.GetBlogOrderHistoriesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.profileservice.GetBlogOrderHistoriesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderHistoriesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    blogOrderHistoriesList: jspb.Message.toObjectList(msg.getBlogOrderHistoriesList(),
    proto.profileservice.BlogOrderHistory.toObject, includeInstance),
    page: jspb.Message.getFieldWithDefault(msg, 2, 0),
    perPage: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply}
 */
proto.profileservice.GetBlogOrderHistoriesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.profileservice.GetBlogOrderHistoriesReply;
  return proto.profileservice.GetBlogOrderHistoriesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.profileservice.GetBlogOrderHistoriesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply}
 */
proto.profileservice.GetBlogOrderHistoriesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.profileservice.BlogOrderHistory;
      reader.readMessage(value,proto.profileservice.BlogOrderHistory.deserializeBinaryFromReader);
      msg.addBlogOrderHistories(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPerPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.profileservice.GetBlogOrderHistoriesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.profileservice.GetBlogOrderHistoriesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.profileservice.GetBlogOrderHistoriesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBlogOrderHistoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.profileservice.BlogOrderHistory.serializeBinaryToWriter
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPerPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * repeated BlogOrderHistory blog_order_histories = 1;
 * @return {!Array<!proto.profileservice.BlogOrderHistory>}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.getBlogOrderHistoriesList = function() {
  return /** @type{!Array<!proto.profileservice.BlogOrderHistory>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.profileservice.BlogOrderHistory, 1));
};


/**
 * @param {!Array<!proto.profileservice.BlogOrderHistory>} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply} returns this
*/
proto.profileservice.GetBlogOrderHistoriesReply.prototype.setBlogOrderHistoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.profileservice.BlogOrderHistory=} opt_value
 * @param {number=} opt_index
 * @return {!proto.profileservice.BlogOrderHistory}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.addBlogOrderHistories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.profileservice.BlogOrderHistory, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply} returns this
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.clearBlogOrderHistoriesList = function() {
  return this.setBlogOrderHistoriesList([]);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply} returns this
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 per_page = 3;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.getPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply} returns this
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.setPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 total_count = 4;
 * @return {number}
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.profileservice.GetBlogOrderHistoriesReply} returns this
 */
proto.profileservice.GetBlogOrderHistoriesReply.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.profileservice);
